module.exports = __webpack_public_path__ + "static/media/objects.f4241aa5.png";